import { tween, styler } from 'popmotion'
import _ from 'lodash'

const VueAnimateOnIntersection = {
  install (Vue) {
    Vue.directive('animate-on-intersection', {
      bind (el) {
        const element = styler(el)
        const observer = new window.IntersectionObserver(entries => {
          _.forEach(entries, entry => {
            if (entry.isIntersecting) {
              tween({
                from: { y: 150, opacity: 0 },
                to: { y: 0, opacity: 1 }
              }).start(element.set)
              observer.unobserve(el)
            }
          })
        })
        observer.observe(el)
      }
    })
  }
}

export default VueAnimateOnIntersection
